import { useGetMunicipalitiesQuery } from "../../store/services/municipalitiesServices";
import { cities } from "../notifications/AddNotification"
import { compactSelectStyles, inputStyle, labelStyle, MultiSelectInput, RangeInput } from "./utils"
import Select from 'react-select';

export const UsersFilters = ({ multiSelectFilters, handleMultiSelectFiltersChange, multiSelectItems, handleMultiSelectItemsChange, rangeItems, handleRangeItemsChange, dropdownMultiSelectItems, handleDropdownMultiSelectChange, handleDeleteMultiSelectFilters }) => {

    const { personal_numbers, bank_account_numbers, bank_ids } = multiSelectItems
    const { start_num_receipts, end_num_receipts, start_sum_with_vat, end_sum_with_vat, start_sum_without_vat, end_sum_without_vat } = rangeItems
    const { municipalities_no } = dropdownMultiSelectItems
    const { personal_numbers: selectedPersonalNumbers, bank_account_numbers: selectedBankAccountNumbers, selectedBankIds, selectedZipCodes } = multiSelectFilters

    const { data: municipalities } = useGetMunicipalitiesQuery()

    return (
        <div className="flex flex-col gap-3">
            <MultiSelectInput
                type="number"
                name="personal_numbers"
                label="Numri personal"
                placeholder="Kerko sipas numrit personal"
                value={personal_numbers}
                handleValueChange={handleMultiSelectItemsChange}
                handleSelectedValuesChange={handleMultiSelectFiltersChange}
                selectedValues={selectedPersonalNumbers}
                handleDeleteMultiSelectFilters={handleDeleteMultiSelectFilters}
            />
            <MultiSelectInput
                type="number"
                name="bank_account_numbers"
                label="Numri i bankës"
                placeholder="Kerko sipas numrit të bankës"
                value={bank_account_numbers}
                handleValueChange={handleMultiSelectItemsChange}
                handleSelectedValuesChange={handleMultiSelectFiltersChange}
                selectedValues={selectedBankAccountNumbers}
                handleDeleteMultiSelectFilters={handleDeleteMultiSelectFilters}
            />
            <div className="flex flex-col gap-1.5">
                <label htmlFor="region" className={labelStyle}>Regjioni</label>
                <Select
                    isMulti
                    name="municipalities_no"
                    styles={compactSelectStyles}
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    options={municipalities?.data.map(municipality => ({
                        value: municipality.municipality_no,
                        label: municipality.municipality_name
                    }))}
                    placeholder="Të gjitha regjionet"
                    onChange={handleDropdownMultiSelectChange}
                    value={municipalities?.data.filter(municipality => municipalities_no?.includes(municipality.municipality_no)).map(municipality => ({
                        value: municipality.municipality_no,
                        label: municipality.municipality_name
                    }))}
                />
            </div>
            <RangeInput
                type="number"
                start_name="start_num_receipts"
                end_name="end_num_receipts"
                label="Numri i kuponave"
                start_placeholder="Nga"
                end_placeholder="Deri"
                start_value={start_num_receipts}
                end_value={end_num_receipts}
                handleValueChange={handleRangeItemsChange}
            />
            <RangeInput
                type="number"
                start_name="start_sum_with_vat"
                end_name="end_sum_with_vat"
                label="Shuma totale me TVSH"
                start_placeholder="Nga"
                end_placeholder="Deri"
                start_value={start_sum_with_vat}
                end_value={end_sum_with_vat}
                handleValueChange={handleRangeItemsChange}
            />
            <RangeInput
                type="number"
                start_name="start_sum_without_vat"
                end_name="end_sum_without_vat"
                label="Shuma totale pa TVSH"
                start_placeholder="Nga"
                end_placeholder="Deri"
                start_value={start_sum_without_vat}
                end_value={end_sum_without_vat}
                handleValueChange={handleRangeItemsChange}
            />
        </div >
    )
}